module.exports = __webpack_public_path__ + "static/media/vektskål.9fc6974e.m4a";